<div class="page-container" [class.loading]="isLoading">
    <app-header title="payroll.menuItemLabels.benefitsAndDeductions" [menuService]="payrollModuleMenuService" />
    <h2 class="no-margin">{{ 'payroll.dental-benefits.title' | translate }}</h2>
    <ui-card [withSpacing]="false">
        @if (dentalBenefitsTable) {
            <app-table
                [isResponsive]="true"
                [showOffset]="true"
                [noPadding]="true"
                [showActionsPadding]="false"
                [embedded]="true"
                [showSearch]="false"
                [useStickyHeader]="false"
                [table]="dentalBenefitsTable"
                [showPagination]="false"
            >
                <app-empty-state class="empty-state" />
            </app-table>
        }
    </ui-card>
</div>
